"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var HeaderTooltip_1 = __importDefault(require("containers/TableMaker/components/HeaderTooltip"));
var SortableArrows_1 = __importDefault(require("./SortableArrows"));
var SortButton_1 = __importDefault(require("./SortButton"));
var SortContext_1 = __importDefault(require("./SortContext"));
var utils_1 = require("./utils");
var SortableHeader = function (_a) {
    var sortKey = _a.sortKey, text = _a.text, _b = _a.defaultOrder, defaultOrder = _b === void 0 ? 1 : _b, headerTooltip = _a.headerTooltip, rest = __rest(_a, ["sortKey", "text", "defaultOrder", "headerTooltip"]);
    var _c = (0, react_1.useContext)(SortContext_1.default), setSort = _c.setSort, sort = _c.sort;
    var title = (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [text, " ", sortKey && (0, jsx_runtime_1.jsx)(SortableArrows_1.default, { sortOrder: sort && sort.key === sortKey ? sort.order : undefined })] });
    return ((0, jsx_runtime_1.jsx)(SortButton_1.default, __assign({}, rest, { onClick: sortKey ? (0, utils_1.makeToggleSort)(setSort, sortKey, defaultOrder, sort) : undefined, isSelected: sort && sort.key === sortKey, hasSortKey: !!sortKey, className: sortKey ? '' : 'non-sortable', tabIndex: sortKey ? 0 : -1 }, { children: headerTooltip
            ? (0, jsx_runtime_1.jsx)(HeaderTooltip_1.default, __assign({ title: text, description: headerTooltip === null || headerTooltip === void 0 ? void 0 : headerTooltip.description, list: headerTooltip === null || headerTooltip === void 0 ? void 0 : headerTooltip.list }, { children: title }))
            : title })));
};
exports.default = SortableHeader;
